var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-levels"},_vm._l((_vm.levelsCount),function(levelNumber){return _c('div',{key:levelNumber,staticClass:"grid-levels__level",class:{
      'grid-levels__level--active': levelNumber === _vm.currentLevel,
    },attrs:{"data-testid":("level-number-" + levelNumber)}},[_vm._v(" "+_vm._s(levelNumber)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }